import type { FeatureManifest } from '@/platform/navigation/featureManifest'

export const communicativeFunctionsManifest: FeatureManifest = {
  id: 'catalog-communicative-functions',
  path: 'catalogs/communicative-functions/*',
  navPath: '/catalogs/communicative-functions',
  label: 'Chức năng giao tiếp',
  description: 'Danh mục chức năng giao tiếp bằng tiếng Anh',
  navigationGroup: { id: 'catalogs', label: 'Danh mục' },
  load: () => import('./entry'),
}
